import React, { createContext, useContext, useEffect, useState } from "react";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  const refresh = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`);
      const data = await res.json();
      setContent(data);
      return data;
    } catch (e) {
      setError(e.message);
      return null;
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return <ContentContext.Provider value={{ content, error, refresh }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
